export default [
  {
    key: "title",
    label: "field.title",
    rules: "required|max:100",
    type: "text",
    cols: 12,
  },
  {
    key: "image",
    label: "field.brandLogo",
    initKey: "brandLogo",
    rules: "size:10000",
    type: "single-image",
    pw: 150,
    ph: 150,
    fullWidth: false,
    cols: 12,
  },
  {
    key: "color",
    label: "field.brandColor",
    rules: "required|max:10",
    type: "color-picker",
    cols: 'auto',
    fullWidth: true,
    showColorPlaceholder: true,
  },
  {
    key: "bodyBackgroundColor",
    label: "field.bodyBackgroundColor",
    rules: "required|max:10",
    type: "color-picker",
    fullWidth: true,
    cols: 'auto',
    showColorPlaceholder: true,
  },
  {
    key: "size",
    label: "field.size",
    type: "radio",
    rules: "required",
    options: [
      { text: "field.s", value: "s" },
      { text: "field.m", value: "m" },
    ],
    cols: 12,
  },

  {
    key: "hoverText",
    label: "field.hoverText",
    rules: "max:100",
    type: "text",
    cols: 12,
  },
  {
    key: "imageBot",
    label: "field.botIcon",
    initKey: "botLogo",
    rules: "size:10000",
    type: "single-image",
    pw: 150,
    ph: 150,
    fullWidth: false,
    cols: 12,
  },
  {
    key: "typeIndicator",
    label: "field.isShowTyping",
    rules: "",
    type: "checkbox",
    cols: "auto",
  },
  {
    key: "placeholderText",
    label: "field.placeholderText",
    rules: "max:200",
    type: "textEditor",
    cols: 12,
  },
];
